export const queryKeys = {
  auth: {
    login: ['auth', 'login'] as const,
    changePassword: ['auth', 'change-password'] as const,
    resetPassword: ['auth', 'reset-password'] as const,
    forgotPassword: ['auth', 'forgot-password'] as const,
    forgotPasswordConfirm: ['auth', 'forgot-password-confirm'] as const,
  },
  agents: {
    all: ['agents'] as const,
    list: (page = 1, pageSize?: number, query = '', filters = {}) =>
      ['agents', page, pageSize, query, filters] as const,
    detail: (agentId: string) => ['agentDetail', agentId] as const,
    detailAll: ['agentDetail'] as const,
    voices: ['agentVoices'] as const,
    llmModels: ['llmModels'] as const,
    templates: ['agentTemplates'] as const,
    unassociated: ['unassociatedAgents'] as const,
    knowledgeBases: (agentId: number, linked?: boolean) =>
      ['agent-knowledge-bases', agentId, linked] as const,
    tools: (agentId: number, linked?: boolean) => ['agent-tools', agentId, linked] as const,
    mutations: {
      create: ['agents', 'create'] as const,
      delete: ['agents', 'delete'] as const,
      update: ['agents', 'update'] as const,
      updateStatus: ['agents', 'update-status'] as const,
      linkKnowledgeBase: ['agents', 'link-knowledge-base'] as const,
      unlinkKnowledgeBase: ['agents', 'unlink-knowledge-base'] as const,
      linkTool: ['agents', 'link-tool'] as const,
      unlinkTool: ['agents', 'unlink-tool'] as const,
    },
  },
  calls: {
    all: ['calls'] as const,
    list: (page = 1, pageSize?: number, query = '', filters = {}) =>
      ['calls', page, pageSize, query, filters] as const,
    detail: (callId: number) => ['call-detail', callId] as const,
    transcripts: (callId: number) => ['call-transcripts', callId] as const,
    recording: (callId: number) => ['call-recording', callId] as const,
    mutations: {
      dispatchWeb: ['calls', 'dispatch-web'] as const,
      dispatchPhone: ['calls', 'dispatch-phone'] as const,
    },
  },
  dashboard: {
    all: ['dashboard'] as const,
    byFilters: (filters: { from_date: string; to_date: string; agent_id?: number | null }) =>
      ['dashboard', filters.from_date, filters.to_date, filters.agent_id ?? null] as const,
    auditLogs: (page = 1, pageSize?: number, query = '', filters = {}) =>
      ['dashboard-audit-logs', page, pageSize, query, filters] as const,
  },
  roles: {
    all: ['roles'] as const,
    detail: (id: number) => ['role', id] as const,
    permissions: ['permissions'] as const,
    mutations: {
      create: ['roles', 'create'] as const,
      update: ['roles', 'update'] as const,
      delete: ['roles', 'delete'] as const,
    },
  },
  apiKeys: {
    all: ['apiKeys'] as const,
    list: (page = 1, pageSize?: number, query = '') => ['apiKeys', page, pageSize, query] as const,
    mutations: {
      create: ['apiKeys', 'create'] as const,
      delete: ['apiKeys', 'delete'] as const,
    },
  },
  users: {
    all: ['users'] as const,
    list: (page = 1, pageSize?: number, query = '') => ['users', page, pageSize, query] as const,
    current: ['currentUser'] as const,
    invitations: ['userInvitations'] as const,
    mutations: {
      delete: ['users', 'delete'] as const,
      updateRole: ['users', 'update-role'] as const,
      updateProfile: ['users', 'update-profile'] as const,
      invite: ['users', 'invite'] as const,
      resendInvitation: ['users', 'resend-invitation'] as const,
    },
  },
  phoneNumbers: {
    all: ['phone-numbers'] as const,
    list: (page = 1, pageSize?: number, query = '') =>
      ['phone-numbers', page, pageSize, query] as const,
    mutations: {
      create: ['phone-numbers', 'create'] as const,
      assignAgent: ['phone-numbers', 'assign-agent'] as const,
      delete: ['phone-numbers', 'delete'] as const,
    },
  },
  knowledgeBases: {
    all: ['knowledge-bases'] as const,
    list: (page = 1, pageSize?: number, query = '') =>
      ['knowledge-bases', page, pageSize, query] as const,
    detail: (kbId: number) => ['knowledge-base', kbId] as const,
    syncStatus: (kbId: number) => ['knowledge-base-sync', kbId] as const,
    filePreview: (filePath: string) => ['knowledge-base-file-preview', filePath] as const,
    mutations: {
      create: ['knowledge-bases', 'create'] as const,
      update: ['knowledge-bases', 'update'] as const,
      delete: ['knowledge-bases', 'delete'] as const,
      deleteDocument: ['knowledge-bases', 'delete-document'] as const,
      uploadDocument: ['knowledge-bases', 'upload-document'] as const,
      sync: ['knowledge-bases', 'sync'] as const,
    },
  },
  tools: {
    all: ['tools'] as const,
    list: (page = 1, pageSize?: number, query = '') => ['tools', page, pageSize, query] as const,
    detail: (toolId: string) => ['tool', toolId] as const,
    mutations: {
      create: ['tools', 'create'] as const,
      update: ['tools', 'update'] as const,
      delete: ['tools', 'delete'] as const,
    },
  },
  transferConfigurations: {
    detail: (agentId: number) => ['transfer-configuration', agentId] as const,
    mutations: {
      upsert: ['transfer-configuration', 'upsert'] as const,
    },
  },
  batchCalls: {
    all: ['batch-calls'] as const,
    list: (page = 1, pageSize?: number, query = '', filters = {}) =>
      ['batch-calls', page, pageSize, query, filters] as const,
    detail: (id: number) => ['batch-call-detail', id] as const,
    recipients: (id: number, page = 1, pageSize?: number) =>
      ['batch-call-recipients', id, page, pageSize] as const,
    mutations: {
      create: ['batch-calls', 'create'] as const,
      update: ['batch-calls', 'update'] as const,
      delete: ['batch-calls', 'delete'] as const,
      updateRecipient: ['batch-calls', 'update-recipient'] as const,
      deleteRecipient: ['batch-calls', 'delete-recipient'] as const,
      downloadTemplate: ['batch-calls', 'download-template'] as const,
    },
  },
};
